export const Users = 'Users';
export const AuctionRoomsCollection = 'AuctionRooms';
export const TrustIssuesRoomCollection = 'TrustIssues';
export const Teams = 'Teams';
export const Lobby = 'Lobby';
export const ImpostorGameTeams = "ImpostorGameTeams";
export const ColorGrids = "ColorGrids";